import { render, staticRenderFns } from "./WhatsYourOut.vue?vue&type=template&id=2b64b744"
import script from "./WhatsYourOut.vue?vue&type=script&lang=ts"
export * from "./WhatsYourOut.vue?vue&type=script&lang=ts"
import style0 from "./WhatsYourOut.vue?vue&type=style&index=0&id=2b64b744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports